<template>
    <td-dialog
        :title="$t(title)"
        @cancel="propertyDialogClose"
        :before-close="propertyDialogClose"
        :visible.sync="dialogPropertyVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
        top="18vh"
    >
        <el-form :model="formProperty" ref="formProperty" :rules="rules" label-position="right" label-width="65px">
            <el-form-item :label="$t('pgCommon.PROPERTY_NAME')" prop="sPropertyName">
                <td-input v-model="formProperty.sPropertyName" :disabled="keyDisable"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.PROPERTY_VALUE')" prop="sPropertyValue">
                <td-input type="textarea" :rows="rows" v-model="formProperty.sPropertyValue" width="100%" @change="changeInput"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formProperty')">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import dlgPropertyApi from './../assets/api.js';
export default {
    props: ['title', 'dialogPropertyVisible', 'editItem', 'treeNode', 'isAddData'],
    created() {
        this.editItemNew = this.editItem;
        this.fileNode = this.treeNode;
        if (this.fileNode.label != null && this.fileNode.label != '' && this.fileNode.label != undefined) {
            let labels = this.fileNode.label.split('.');
            if (labels.length > 1) {
                this.fileType = labels[1];
            }
        }
        // 为编辑状态则进行初始化数据
        if (this.isAddData) {
            this.keyDisable = false;
        } else {
            this.initEditData();
            this.keyDisable = true;
        }
    },
    // 定义变量
    data() {
        let validateKey = (rule, value, callback) => {
            if (this.fileType === 'json') {
                if (value.indexOf('=') > 0) {
                    callback(this.$t('pgError.ERROR_INPUT_ILLAGE_SPECAIL_CHAR'));
                }
            } else if (this.fileType === 'properties') {
                if (value.indexOf('=') > 0) {
                    callback(this.$t('pgError.ERROR_INPUT_ILLAGE_SPECAIL_CHAR'));
                }
            } else if (this.fileType === 'xml') {
                if (value.indexOf('=') > 0) {
                    callback(this.$t('pgError.ERROR_INPUT_ILLAGE_SPECAIL_CHAR'));
                }
            } else if (this.fileType === 'ini') {
                if (value.indexOf('.') < 1) {
                    callback(this.$t('pgError.ERROR_FORMAT'));
                }
                if (value.indexOf('=') > 0) {
                    callback(this.$t('pgError.ERROR_INPUT_ILLAGE_SPECAIL_CHAR'));
                }
            }
            callback();
        };
        let validateValue = (rule, value, callback) => {
            if (this.fileType === 'json') {
                if (value.indexOf('=') > 0) {
                    callback(this.$t('pgError.ERROR_INPUT_ILLAGE_SPECAIL_CHAR'));
                }
            } else if (this.fileType === 'properties') {
                if (value.indexOf('=') > 0) {
                    callback(this.$t('pgError.ERROR_INPUT_ILLAGE_SPECAIL_CHAR'));
                }
            } else if (this.fileType === 'xml') {
                if (value.indexOf('=') > 0) {
                    callback(this.$t('pgError.ERROR_INPUT_ILLAGE_SPECAIL_CHAR'));
                }
            } else if (this.fileType === 'ini') {
                if (value.indexOf('=') > 0) {
                    callback(this.$t('pgError.ERROR_INPUT_ILLAGE_SPECAIL_CHAR'));
                }
            }
            callback();
        };
        return {
            // 表单信息
            formProperty: {
                sPropertyName: '',
                sPropertyValue: ''
            },
            keyDisable: false,
            rows: 3,
            fileType: null, //文件类型
            fileNode: null, //树形选中节点信息
            // 对表单进行数据验证
            rules: {
                sPropertyName: [
                    { required: true, message: this.$t('pgError.ERROR_KEY_NULL'), trigger: 'blur' },
                    { validator: validateKey, trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                sPropertyValue: [{ required: true, message: this.$t('pgError.ERROR_VALUE_NULL'), trigger: 'blur' }, { validator: validateValue, trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formProperty.sPropertyName = this.editItemNew.sPropertyName;
            this.formProperty.sPropertyValue = this.formatJson(this.editItemNew.sPropertyValue);
        },

        // 输入框change事件
        changeInput() {
            if (this.formProperty.sPropertyValue.length > 1080) {
                this.rows = 20;
            } else {
                this.rows = 3;
            }
        },

        // 格式化json格式数据
        formatJson(json) {
            try {
                let reg = null;
                let formatted = '';
                let pad = 0;
                let PADDING = '    ';
                let options = {};
                options.newlineAfterColonIfBeforeBraceOrBracket = options.newlineAfterColonIfBeforeBraceOrBracket === true;
                options.spaceAfterColon = options.spaceAfterColon !== false;
                if (typeof json !== 'string') {
                    json = JSON.stringify(json);
                } else {
                    json = JSON.parse(json);
                    json = JSON.stringify(json);
                }
                reg = /([{}])/g;
                json = json.replace(reg, '$1\r\n');
                reg = /([[\]])/g;
                json = json.replace(reg, '\r\n$1\r\n');
                reg = /(,)/g;
                json = json.replace(reg, '$1\r\n');
                reg = /(\r\n\r\n)/g;
                json = json.replace(reg, '\r\n');
                reg = /\r\n,/g;
                json = json.replace(reg, ',');
                if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
                    reg = /:\r\n\{/g;
                    json = json.replace(reg, ':{');
                    reg = /:\r\n\[/g;
                    json = json.replace(reg, ':[');
                }
                if (options.spaceAfterColon) {
                    reg = /:/g;
                    json = json.replace(reg, ':');
                }
                json.split('\r\n').forEach(function(node) {
                    if (node === '') {
                        return;
                    }
                    let i = 0;
                    let indent = 0;
                    let padding = '';

                    if (node.match(/\{$/) || node.match(/\[$/)) {
                        indent = 1;
                    } else if (node.match(/\}/) || node.match(/\]/)) {
                        if (pad !== 0) {
                            pad -= 1;
                        }
                    } else {
                        indent = 0;
                    }
                    for (i = 0; i < pad; i++) {
                        padding += PADDING;
                    }
                    formatted += padding + node + '\r\n';
                    pad += indent;
                });
                return formatted;
            } catch (error) {
                return json;
            }
        },

        // 提交数据
        submitForm(formProperty) {
            this.$refs[formProperty].validate(valid => {
                if (valid) {
                    let str = this.formProperty.sPropertyValue.replace(/[\r\n]/g, '');
                    let content = {
                        sFilePath: this.fileNode.id,
                        sPropertyName: this.formProperty.sPropertyName,
                        sPropertyValue: str
                    };
                    if (this.isAddData) {
                        content.sFileType = this.fileType;
                        dlgPropertyApi.checkPropertyExist(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dlgPropertyApi.updateConfigFile', response);
                                return;
                            }
                            if (response.data.content) {
                                this.$confirm(this.$t('pgCommon.PROPERTY_NAME_EXIST_IS_REPLACE'), this.$t('pgCommon.TIPS'), {
                                    confirmButtonText: this.$t('pgCommon.SURE'),
                                    cancelButtonText: this.$t('pgCommon.CANCEL'),
                                    type: 'warning'
                                }).then(() => {
                                    dlgPropertyApi.insertConfigFile(JSON.stringify(content), response => {
                                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                            this.$log.error('dlgPropertyApi.insertConfigFile', response);
                                            return;
                                        }
                                        this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS_QUERY_AGAIN'), type: 'success' });
                                        this.$emit('successQuery');
                                        this.propertyDialogClose();
                                    });
                                });
                            } else {
                                dlgPropertyApi.insertConfigFile(JSON.stringify(content), response => {
                                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                        this.$log.error('dlgPropertyApi.insertConfigFile', response);
                                        return;
                                    }
                                    this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS_QUERY_AGAIN'), type: 'success' });
                                    this.$emit('successQuery');
                                    this.propertyDialogClose();
                                });
                            }
                        });
                    } else {
                        dlgPropertyApi.updateConfigFile(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dlgPropertyApi.updateConfigFile', response);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('pgCommon.MODIFY_SUCCESS_QUERY_AGAIN'), type: 'success' });
                            this.$emit('successQuery');
                            this.propertyDialogClose();
                        });
                    }
                }
            });
        },

        // 取消
        cancel() {
            this.propertyDialogClose();
        },

        // 关闭窗口之前需要调用的方法
        propertyDialogClose() {
            this.$emit('propertyDialogClose');
            this.$refs['formProperty'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
